"use strict";

exports.__esModule = true;
exports.DropdownCheckboxListContainer = exports.DropdownCheckboxList = exports.DropdownCheckboxHeader = exports.AllCheckBoxRow = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _select = require("@blueprintjs/select");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _SearchInput = require("../SearchInput");
var _Theme = require("../../Theme");
var _Translator = require("../Translator");
var _RenderItem = require("./RenderItem");
var _RenderVirtualizedList = require("./RenderVirtualizedList");
var _class, _DropdownCheckboxList;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var SELECT_POPOVER_CLASSNAME = "vi-select-popover";
var GlobalStyles = (0, _styledComponents.createGlobalStyle)(["body{.", "{.", " .", "{max-height:300px;overflow-y:auto;}}}"], SELECT_POPOVER_CLASSNAME, _core.Classes.POPOVER_CONTENT, _core.Classes.MENU);
var DropdownCheckboxHeader = exports.DropdownCheckboxHeader = _styledComponents["default"].div.withConfig({
  displayName: "DropdownCheckboxList__DropdownCheckboxHeader",
  componentId: "sc-tgghjc-0"
})(["padding:10px 10px 5px;"]);
var AllCheckBoxRow = exports.AllCheckBoxRow = (0, _styledComponents["default"])(_core.Menu).withConfig({
  displayName: "DropdownCheckboxList__AllCheckBoxRow",
  componentId: "sc-tgghjc-1"
})(["border-bottom:1px solid #ccc;padding:0 5px;"]);
var DropdownCheckboxListContainer = exports.DropdownCheckboxListContainer = _styledComponents["default"].div.withConfig({
  displayName: "DropdownCheckboxList__DropdownCheckboxListContainer",
  componentId: "sc-tgghjc-2"
})([".", "{align-items:center;}.", "{width:16px;height:16px;box-shadow:inset 0 0 0 1px rgba(16,22,26,0.4),inset 0 -1px 0 rgba(16,22,26,0.2);background-color:", ";background-image:linear-gradient( to bottom,rgba(255,255,255,0.1),rgba(255,255,255,0) );display:flex;align-items:center;justify-content:center;border-radius:3px;font-size:16px;.", "{color:#ffffff;}}"], _core.Classes.MENU_ITEM, _core.Classes.CONTROL_INDICATOR, (0, _Theme.val)("bp6-intent-primary"), _core.Classes.ICON);
var SelectorButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "DropdownCheckboxList__SelectorButton",
  componentId: "sc-tgghjc-3"
})(["padding:0 5px;.", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;}.", "{padding:5px 0px 5px 0px;}"], _core.Classes.BUTTON_TEXT, _core.Classes.TEXT_OVERFLOW_ELLIPSIS);

/**
 * Allows a user to select item(s) from a checkbox list.
 */
var DropdownCheckboxList = exports.DropdownCheckboxList = (0, _Translator.withTranslator)(_class = (_DropdownCheckboxList = /*#__PURE__*/function (_Component) {
  function DropdownCheckboxList() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.hasMounted = false;
    _this.state = {
      query: "",
      isOpen: false
    };
    _this.registerInputRef = function (input) {
      _this.input = input;
    };
    _this.registerQueryListRef = function (queryList) {
      _this.queryList = queryList;
    };
    _this.handleSelect = function (item) {
      if (_this.input != null) {
        _this.input.focus();
      }
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        getKey = _this$props.getKey,
        selected = _this$props.selected,
        getClickedItem = _this$props.getClickedItem;
      if (getClickedItem) {
        getClickedItem(item);
      }
      var updated = [];
      var itemKey = getKey(item);
      var found = false;
      for (var i = 0; i < selected.length; i++) {
        var selectedItem = selected[i];
        var key = typeof selectedItem === "number" || typeof selectedItem === "string" ? selectedItem : getKey(selectedItem);
        var target = _this.getItemByKey(key);
        if (target === undefined) {
          continue;
        }
        if (key === itemKey) {
          found = true;
        } else {
          updated.push(target);
        }
      }
      if (!found) {
        updated.push(item);
      }

      // $FlowFixMe
      onSelect(updated);
    };
    _this.toggleSelectAll = function (filteredItems) {
      var _this$props2 = _this.props,
        onSelect = _this$props2.onSelect,
        items = _this$props2.items,
        shouldSelectAllFiltered = _this$props2.shouldSelectAllFiltered,
        getKey = _this$props2.getKey;
      if (_this.state.query && _this.state.query.length > 0 && shouldSelectAllFiltered) {
        var selectedItemSet = _this.createSelectedItemSet(_this.props.selected);
        var remainingItems = [];
        filteredItems.forEach(function (item) {
          if (!selectedItemSet.has(getKey(item))) {
            remainingItems.push(item);
          }
        });
        if (remainingItems.length > 0) {
          // selection
          onSelect([].concat(_this.props.selected, remainingItems));
        } else {
          // deselection
          _this.props.selected.forEach(function (selectedItem) {
            if (!filteredItems.find(function (item) {
              return getKey(item) === getKey(selectedItem);
            })) {
              remainingItems.push(selectedItem);
            }
          });
          onSelect(remainingItems);
        }
      } else {
        if (_this.isAllSelected()) {
          onSelect([]);
        } else {
          onSelect(items.slice());
        }
      }
    };
    _this.handlePopoverInteraction = function () {
      return requestAnimationFrame(function () {
        if (!_this.hasMounted) {
          return;
        }
        // deferring to rAF to get properly updated activeElement
        if (_this.input != null && _this.input !== document.activeElement) {
          // the input is no longer focused so we can close the popover
          _this.setState({
            isOpen: false
          });
        } else {
          if (!_this.props.disabled) {
            _this.setState({
              isOpen: true
            });
          }
        }
      });
    };
    _this.handlePopoverOpened = function () {
      if (_this.queryList != null) {
        _this.queryList.scrollActiveItemIntoView();
      }
    };
    _this.isItemSelected = function (item) {
      var _this$props3 = _this.props,
        selected = _this$props3.selected,
        getKey = _this$props3.getKey;
      var itemKey = getKey(item);
      for (var i = 0; i < selected.length; i++) {
        var selectedItem = selected[i];
        var key = typeof selectedItem === "object" && selectedItem !== null ? getKey(selectedItem) : selectedItem;
        if (key === itemKey) {
          return true;
        }
      }
      return false;
    };
    _this.handleQueryChange = function (query) {
      _this.setState({
        query: query
      });
    };
    _this.isAllSelected = function () {
      return _this.props.selected.length === 0 && _this.props.selectAllByDefault || _this.props.selected.length && _this.props.items.length === _this.props.selected.length;
    };
    _this.isAllFilteredSelected = function (filteredItems, selectedItems, getKey) {
      var selectedItemSet = _this.createSelectedItemSet(selectedItems);
      if (selectedItems.length < 1) {
        return false;
      }
      var allSelected = true;
      filteredItems.forEach(function (item) {
        if (!selectedItemSet.has(getKey(item))) {
          allSelected = false;
        }
      });
      return allSelected;
    };
    _this.createSelectedItemSet = function (selectedItems) {
      var selectedItemSet = new Set();
      selectedItems.forEach(function (item) {
        return selectedItemSet.add(_this.props.getKey(item));
      });
      return selectedItemSet;
    };
    _this.getSelectedItems = function () {
      var _this$props4 = _this.props,
        selected = _this$props4.selected,
        items = _this$props4.items,
        getKey = _this$props4.getKey;
      return selected.length === 0 ? [] : selected.map(function (key) {
        return typeof key === "object" && key !== null ? key : lookup(items, getKey, key);
      });
    };
    _this.renderQueryList = function (listProps) {
      var _this$props5 = _this.props,
        className = _this$props5.className,
        icon = _this$props5.icon,
        minimal = _this$props5.minimal,
        large = _this$props5.large,
        small = _this$props5.small,
        style = _this$props5.style,
        rightIcon = _this$props5.rightIcon,
        isOpen = _this$props5.isOpen,
        _this$props5$usePorta = _this$props5.usePortal,
        usePortal = _this$props5$usePorta === void 0 ? true : _this$props5$usePorta,
        onInteraction = _this$props5.onInteraction,
        children = _this$props5.children,
        disabled = _this$props5.disabled,
        dataTestId = _this$props5.dataTestId,
        popoverProps = _this$props5.popoverProps;
      var selectedItems = _this.getSelectedItems();
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GlobalStyles, null), /*#__PURE__*/_react["default"].createElement(_core.Popover
      // eslint-disable-next-line jsx-a11y/no-autofocus
      , _extends({
        autoFocus: false,
        canEscapeKeyClose: true,
        enforceFocus: false,
        isOpen: isOpen !== undefined ? isOpen : _this.state.isOpen,
        position: _core.Position.BOTTOM_LEFT,
        usePortal: usePortal,
        popoverClassName: SELECT_POPOVER_CLASSNAME,
        onInteraction: onInteraction || _this.handlePopoverInteraction,
        onOpened: _this.handlePopoverOpened
      }, popoverProps, {
        content: listProps.itemList
      }), children || /*#__PURE__*/_react["default"].createElement(SelectorButton, {
        disabled: disabled,
        style: style,
        minimal: minimal,
        large: large,
        small: small,
        className: className,
        icon: icon,
        rightIcon: rightIcon,
        text: _this.renderSelectionText(selectedItems),
        "data-testid": dataTestId
      })));
    };
    _this.renderList = function (_ref) {
      var query = _ref.query,
        filteredItems = _ref.filteredItems,
        itemsParentRef = _ref.itemsParentRef;
      var _this$props6 = _this.props,
        groups = _this$props6.groups,
        hideSearch = _this$props6.hideSearch,
        translator = _this$props6.translator,
        searchPlaceHolder = _this$props6.searchPlaceHolder,
        shouldSelectAllFiltered = _this$props6.shouldSelectAllFiltered,
        selected = _this$props6.selected,
        getKey = _this$props6.getKey,
        maxListHeight = _this$props6.maxListHeight;
      var groupedItems = [];
      var filteredItemList = filteredItems.map(function (item) {
        if (typeof item === "object") {
          return Object.assign({}, item, {
            isGroup: false
          });
        }
        return item;
      });
      if (groups != null) {
        groupedItems = Object.keys(groups).reduce(function (acc, groupKey) {
          var group = groups[groupKey];
          var groupItems = filteredItems.filter(group);
          if (groupItems.length === 0) {
            return acc;
          }
          var isSelected = _this.isGroupSelected(groupKey);
          var areSomeItemsSelected = _this.areSomeItemsInGroupSelected(groupKey);
          return [].concat(acc, [{
            groupKey: groupKey,
            isSelected: isSelected,
            areSomeItemsSelected: areSomeItemsSelected,
            groupItems: groupItems,
            group: group,
            isGroup: true
          }]);
        }, []);
      }
      var items = [].concat(groupedItems, filteredItemList);
      return /*#__PURE__*/_react["default"].createElement(DropdownCheckboxListContainer, {
        "data-testid": "DropdownCheckboxListContainer"
      }, !hideSearch && /*#__PURE__*/_react["default"].createElement(DropdownCheckboxHeader, null, /*#__PURE__*/_react["default"].createElement(_SearchInput.SearchInput, {
        "data-testid": "searchbox"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: true,
        placeholder: searchPlaceHolder,
        type: "search",
        value: query,
        onChange: _this.handleQueryChange,
        inputRef: _this.registerInputRef
      })), /*#__PURE__*/_react["default"].createElement(AllCheckBoxRow, {
        "data-testid": "checkbox-row"
      }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        shouldDismissPopover: false,
        key: "ALL_ITEM",
        "data-testid": "SelectAllButton",
        onClick: function onClick() {
          return _this.toggleSelectAll(filteredItems);
        },
        icon: /*#__PURE__*/_react["default"].createElement("span", {
          className: _core.Classes.CONTROL_INDICATOR
        }, shouldSelectAllFiltered && (query == null ? void 0 : query.length) > 0 && _this.isAllFilteredSelected(filteredItems, selected, getKey) || _this.isAllSelected() ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
          icon: _icons.IconNames.SMALL_TICK
        }) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
          icon: _icons.IconNames.BLANK
        })),
        text: translator.translate("DropdownCheckboxList.all", "(All)")
      })), filteredItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.Menu, {
        ulRef: itemsParentRef
      }, /*#__PURE__*/_react["default"].createElement(_RenderVirtualizedList.RenderVirtualizedList, _extends({}, _this.props, {
        items: items,
        height: heightOfList(items, maxListHeight),
        input: _this.input,
        query: _this.state.query,
        handleSelect: _this.handleSelect,
        getSelectedItems: _this.getSelectedItems,
        isItemSelected: _this.isItemSelected
      }))));
    };
    return _this;
  }
  _inheritsLoose(DropdownCheckboxList, _Component);
  var _proto = DropdownCheckboxList.prototype;
  _proto.isGroupSelected = function isGroupSelected(groupKey) {
    var _this$props7 = this.props,
      groups = _this$props7.groups,
      items = _this$props7.items;
    if (groups == null) {
      return false;
    }
    var group = groups[groupKey];
    if (group == null) {
      return false;
    }
    var groupItems = items.filter(group);
    var selectedGroupItems = groupItems.filter(this.isItemSelected, this);
    return selectedGroupItems.length === groupItems.length;
  };
  _proto.areSomeItemsInGroupSelected = function areSomeItemsInGroupSelected(groupKey) {
    var _this$props8 = this.props,
      groups = _this$props8.groups,
      items = _this$props8.items;
    if (groups == null) {
      return false;
    }
    var group = groups[groupKey];
    if (group == null) {
      return false;
    }
    var groupItems = items.filter(group);
    var selectedGroupItems = groupItems.filter(this.isItemSelected, this);
    return selectedGroupItems.length !== 0;
  };
  _proto.getItemByKey = function getItemByKey(key) {
    var _this$props9 = this.props,
      getKey = _this$props9.getKey,
      items = _this$props9.items;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (getKey(item) === key) {
        return item;
      }
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.hasMounted = true;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hasMounted = false;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props0 = this.props,
      items = _this$props0.items,
      itemPredicate = _this$props0.itemPredicate,
      noResults = _this$props0.noResults,
      renderList = _this$props0.renderList;
    return /*#__PURE__*/_react["default"].createElement(_select.QueryList, {
      ref: this.registerQueryListRef,
      itemRenderer: function itemRenderer(item, _ref2) {
        var handleClick = _ref2.handleClick,
          _ref2$style = _ref2.style,
          style = _ref2$style === void 0 ? {} : _ref2$style;
        return /*#__PURE__*/_react["default"].createElement(_RenderItem.RenderItem, _extends({
          isItemSelected: _this2.isItemSelected,
          handleSelect: handleClick,
          item: item,
          style: style
        }, _this2.props));
      },
      items: items,
      onItemSelect: this.handleSelect,
      itemPredicate: itemPredicate,
      itemListRenderer: renderList || this.renderList,
      renderer: this.renderQueryList,
      noResults: noResults,
      query: this.state.query
    });
  };
  _proto.renderItemCountText = function renderItemCountText(selectedItems) {
    var renderCountText = this.props.renderCountText;
    return /*#__PURE__*/_react["default"].createElement(_core.Text, {
      "data-testid": "selectionText"
    }, renderCountText ? renderCountText(selectedItems.length, this.isAllSelected()) : selectedItems.length);
  };
  _proto.renderSelectionText = function renderSelectionText(selectedItems) {
    var _this$props1 = this.props,
      placeholder = _this$props1.placeholder,
      renderItemText = _this$props1.renderItemText,
      showItemCount = _this$props1.showItemCount;
    var _this$props$allPlaceh = this.props.allPlaceholder,
      allPlaceholder = _this$props$allPlaceh === void 0 ? placeholder : _this$props$allPlaceh;
    var hasSelection = selectedItems.length > 0;
    if (!hasSelection) {
      return placeholder;
    }
    if (this.isAllSelected() && !showItemCount) {
      return allPlaceholder;
    }
    if (showItemCount) return this.renderItemCountText(selectedItems);
    return /*#__PURE__*/_react["default"].createElement(_core.Text, {
      ellipsize: true,
      "data-testid": "selectionText"
    }, selectedItems.reduce(function (output, item, currentIndex, all) {
      var text = renderItemText(item);
      if (typeof text === "string") {
        output.push(text);
      } else {
        output.push(/*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: String(currentIndex)
        }, text));
      }
      var isLast = currentIndex === all.length - 1;
      if (!isLast) {
        output.push(", ");
      }
      return output;
    }, []));
  };
  return DropdownCheckboxList;
}(_react.Component), _DropdownCheckboxList.defaultProps = {
  translator: undefined,
  rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL,
  selected: [],
  placeholder: "Select",
  searchPlaceHolder: "Search",
  hideSearch: false,
  disabled: false,
  dataTestId: "SelectorButton",
  popoverProps: {},
  maxListHeight: 290
}, _DropdownCheckboxList)) || _class;
var heightOfList = function heightOfList(items, defaultHeight) {
  if (defaultHeight === void 0) {
    defaultHeight = 290;
  }
  if (items.length * 30 > defaultHeight) {
    return defaultHeight;
  } else {
    return items.length * 30;
  }
};
function lookup(items, getKey, key) {
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    if (getKey(item) === key) {
      return item;
    }
  }
  return key;
}